var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3836_118249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.27509 23.8493C1.68667 23.8835 1.10799 23.6879 0.661067 23.3037C-0.220356 22.417 -0.220356 20.985 0.661067 20.0983L19.9613 0.798C20.8781 -0.0598406 22.3166 -0.0121537 23.1745 0.904603C23.9502 1.73362 23.9954 3.00784 23.2803 3.88971L3.86635 23.3037C3.42519 23.6823 2.85579 23.8776 2.27509 23.8493Z",
    fill: "#F2000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5516 23.8493C20.9552 23.8468 20.3836 23.6101 19.9602 23.1901L0.659906 3.88969C-0.156685 2.9361 -0.0456652 1.501 0.907923 0.684336C1.75903 -0.0445182 3.01423 -0.0445182 3.86526 0.684336L23.2792 19.9847C24.1957 20.8427 24.2431 22.2814 23.3851 23.1979C23.3509 23.2344 23.3157 23.2696 23.2792 23.3037C22.8038 23.7171 22.1782 23.9147 21.5516 23.8493Z",
    fill: "#F2000B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3836_118249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.ce68161cbc7a3c31f52525736ac586fd.svg";
export { ForwardRef as ReactComponent };